<template>
    <div class="diagram-choose-copper">
        <div class="diagram-content-title" v-if="curChoosedCoper <= 6">点击铜钱{{startAnim ? '结束' : '开始'}}第{{curChoosedCoper}}次摇卦</div>
        <div class="diagram-content-title" v-else-if="parentNode && parentNode.name != 'DiagramEdit'">摇卦结束，请点击起卦<span class="diagram-choose-copper-edit" @click="resetChoosedCoper"><span>重新摇卦</span></span></div>
        <div class="diagram-choose-copper-content" v-if="curChoosedCoper <= 6" @click="clickCoper">
            <span v-for="(cValue, index) in coperArr" :key="cValue+''+index" class="copper" :class="{'copper-bei': cValue == 0, 'copper-zi': cValue == 1}"></span>
        </div>
        <div class="diagram-choose-copper-detail">
            <!-- 六爻 -->
            <div class="diagram-choose-c-d-item" v-show="choosedCoperData && choosedCoperData.six != 0">
                <div class="diagram-choose-c-d-i-title">六爻：</div>
                <div class="diagram-choose-c-d-i-box">
                    <diagram-hand-item :itemType="lineTypeList[choosedCoperData.six]"></diagram-hand-item>
                </div>
            </div>
            <!-- 五爻 -->
            <div class="diagram-choose-c-d-item" v-show="choosedCoperData &&  choosedCoperData.five != 0">
                <div class="diagram-choose-c-d-i-title">五爻：</div>
                <div class="diagram-choose-c-d-i-box">
                    <diagram-hand-item :itemType="lineTypeList[choosedCoperData.five]"></diagram-hand-item>
                </div>
            </div>
            <!-- 四爻 -->
            <div class="diagram-choose-c-d-item" v-show="choosedCoperData &&  choosedCoperData.four != 0">
                <div class="diagram-choose-c-d-i-title">四爻：</div>
                <div class="diagram-choose-c-d-i-box">
                    <diagram-hand-item :itemType="lineTypeList[choosedCoperData.four]"></diagram-hand-item>
                </div>
            </div>
            <!-- 三爻 -->
            <div class="diagram-choose-c-d-item" v-show="choosedCoperData && choosedCoperData.three != 0">
                <div class="diagram-choose-c-d-i-title">三爻：</div>
                <div class="diagram-choose-c-d-i-box">
                    <diagram-hand-item :itemType="lineTypeList[choosedCoperData.three]"></diagram-hand-item>
                </div>
            </div>
            <!-- 二爻 -->
            <div class="diagram-choose-c-d-item" v-show="choosedCoperData && choosedCoperData.two != 0">
                <div class="diagram-choose-c-d-i-title">二爻：</div>
                <div class="diagram-choose-c-d-i-box">
                    <diagram-hand-item :itemType="lineTypeList[choosedCoperData.two]"></diagram-hand-item>
                </div>
            </div>
            <!-- 一爻 -->
            <div class="diagram-choose-c-d-item" v-show="choosedCoperData && choosedCoperData.one != 0">
                <div class="diagram-choose-c-d-i-title">一爻：</div>
                <div class="diagram-choose-c-d-i-box">
                    <diagram-hand-item :itemType="lineTypeList[choosedCoperData.one]"></diagram-hand-item>
                </div>
            </div>
        </div>
        <div v-if="curChoosedCoper >= 1 && curChoosedCoper <= 6" class="diagram-choose-copper-note">
            还剩{{7-curChoosedCoper}}次
        </div>
        <div v-else class="diagram-choose-copper-note">
            请专注只想一件求测的事情，点击钱币开始，再次点击完成一爻，反复六次即可摇出六爻进行起卦
        </div>
    </div>
</template>

<script>
import DiagramHandItem from '../../components/diagram/DiagramHandItem.vue'
import { UTILS } from '../../modules/utils';
export default {
    name: 'DiagramChooseNumber',
    components: { DiagramHandItem },
    props: {
        parentNode: {
            type: Object,
            default() { }
        } 
    },
    computed: {
        curChoosedCoper() {
            return this.$store.state.diagram.curChoosedCoper;
        },
        choosedCoperData() {
            return this.$store.state.diagram.choosedCoperData;
        },
    },
    data() {
        return {
            lineTypeList: ['', 'syin', 'syang', 'lyin', 'lyang'],
            coperArr: [0, 0, 0],
            clickLocked: false,
            startAnim: false,
            endAnim: false,
            animFunc: null
        }
    },
    mounted: function() {

    },
    methods: {
        clickCoper() {
            if(this.clickLocked) { return; }
            this.clickLocked = true;
            setTimeout(() => {
                this.clickLocked = false;
            }, 500);
            if(!this.startAnim) {
                this.startAnim = true;
                this.endAnim = false;
                this.startCoperAnimation();
            }else {
                this.startAnim = false;
                this.endAnim = true;
                this.endCoperAnimation();
            }
        },
        startCoperAnimation() {
            // console.log('startCoperAnimation-----', this.startAnim)
            let me = this, i = 0;
            function anim() {
                i = i === 0 ? 1 : 0;
                me.coperArr = i === 1 ? [1, 1, 1] : [0, 0, 0];
                me.animFunc = setTimeout(() => {
                    if(!me.endAnim) {
                        anim();
                    }
                }, 100);
            }
            anim();
        },
        endCoperAnimation() {
            let coperTotal = 0;
            this.coperArr = [];
            for(let i = 0; i < 3; i++) {
                let temp = UTILS.getRandomInt(2);
                this.coperArr.push(temp);
                coperTotal += temp;
            }
            let lineType = coperTotal%4;
                lineType = coperTotal == 0 || lineType == 0 ? UTILS.getRandomInt(4)+1 : lineType;
            // console.log('endCoperAnimation-----', this.coperArr, coperTotal, lineType)
            setTimeout(() => {
                this.$store.dispatch('diagram/updateDiagramChoosedCoper', lineType);
                if(this.parentNode && this.parentNode.name == 'DiagramEdit') {
                    this.$store.state.diagram.diagramTypeDataChanged = true;
                }
            }, 10);
        },
        resetChoosedCoper() {
            this.$store.dispatch('diagram/resetDiagramChoosedCoper');
        }
    }
}
</script>